import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { Observable, of } from "rxjs";
import { filter, map } from "rxjs/operators";
import { translateAndFormat } from "src/app/i18next";
import { RulesService } from "src/app/services/rules/rules.service";
import { MultiSelectDropdownComponent, Option } from "../multi-select-dropdown/multi-select-dropdown.component";
@Component({
	selector: "app-rule-filter",
	templateUrl: "./rule-filter.component.html",
	styleUrls: ["./rule-filter.component.scss"],
})
export class RuleFilterComponent implements OnInit, OnChanges {
	constructor(private rulesService: RulesService) {}

	@Output() ruleIds: EventEmitter<string[]> = new EventEmitter();

	@Input() companyId: string;
	@Input() isMultiSelect = true;
	@Input() context: string;
	@ViewChild(MultiSelectDropdownComponent, { static: true }) multiSelect;
	rules$: Observable<Option[]> = of([]);
	ruleLabel = translateAndFormat("rule", "capitalize");

	ngOnInit(): void {}

	ngOnChanges(changes: SimpleChanges): void {
		this.companyId = changes?.companyId?.currentValue;
		this.getAllRules();
	}

	clearSelectedOptions() {
		this.multiSelect.selectedOptions = [];
		this.multiSelect.potentiallySelectedOptions = [];
		this.multiSelect.dropdownSubmit();
	}

	getAllRules() {
		if (this.companyId) {
			this.rules$ = this.rulesService.getAllRules(this.companyId).pipe(
				filter(rules => rules?.length > 0),
				map(rules => {
					return rules.map(r => {
						return {
							label: r.name,
							value: r.id,
						};
					});
				}),
			);
		}
	}

	submitDropdownMultiSelect(ids: string[]) {
		this.ruleIds.emit(ids);
	}

	submitDropdownSingleSelect(id: string) {
		this.ruleIds.emit([id]);
	}
}
